module.exports = __webpack_public_path__ + "img/404.7c16a16e.svg";